import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
	UntypedFormArray,
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators,
	ReactiveFormsModule,
	FormsModule,
} from '@angular/forms';
import { CustomFunctionService } from '../../custom-function.service';
import { MatDialog } from '@angular/material/dialog';
import { MonthlyincomecalcComponent } from '../../monthlyincomecalc/monthlyincomecalc.component';
import { Functions } from '@lmc-models/commonFunctions';
import { LookUps } from '@lmc-models/lookUps';
import { User } from '@lmc-app/shared/interface/user.interface';
import { LoanInterviewService } from '@lmc-app/core/services/loan-interview.service';
import { LoanMetaService } from '@lmc-app/core/services/loan-meta.service';
import { BehaviorSubject } from 'rxjs';
import {
	RESIDENCYLIST,
	INSOLVENCYLIST,
	LIABILITYLIST,
} from '../../models/constants';
import { SharedServiceService } from '@lmc-app/shared-service.service';
import {
	MatSelectChange,
	MatSelect,
	MatOption,
} from '@angular/material/select';
import { NgIf, NgFor, AsyncPipe, CurrencyPipe } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import {
	MatTable,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from '@angular/material/table';
import { MatButton } from '@angular/material/button';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import {
	MatFormField,
	MatLabel,
	MatError,
	MatInput,
} from '@angular/material/input';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';

@Component({
	selector: 'app-loan-interview',
	templateUrl: './loan-interview.component.html',
	styleUrls: ['./loan-interview.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		NgIf,
		ReactiveFormsModule,
		FormsModule,
		MatCard,
		MatCardContent,
		NgFor,
		NgSelectComponent,
		NgOptionComponent,
		MatTable,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatCellDef,
		MatCell,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		MatButton,
		NgbAlert,
		NgxSkeletonLoaderComponent,
		MatFormField,
		MatLabel,
		MatSelect,
		MatOption,
		MatSelectSearchComponent,
		MatError,
		MatInput,
		AsyncPipe,
		CurrencyPipe,
	],
})
export class LoanInterviewComponent implements OnInit, OnChanges, OnDestroy {
	@Input() application: any;
	@Input() currentUser: User | null = null;
	@Output() applicationChange = new EventEmitter<any>();

	currentRoute: string;
	currentZohoAppIdFromUrl: string;

	Deal_Name: any;
	displayMonthlyIncome: any;
	totalMonthNumbers: any;
	totalMonthlyIncome: any;
	totalSubformAdditional: any;
	tdsr: any;
	provinceName: any;

	underwritingID: any;

	newAddExpenses: any;
	subjects: any;
	questionBanks: any;

	applicationType: any;

	//Timer
	counter: number;
	timerRef: any;
	running: boolean = false;
	startText = 'Start';
	display_time = '';
	timeInfo: any;
	//Read Only Flag
	readOnly = true;

	// Result from income calculator
	income_calc_result: any;

	// Lookups
	stageName: any;
	creditorName: any;
	primaryEmpStatus: any;
	primaryPayFrequency: any;
	primaryIndustry: any;
	primaryOccupation: any;
	coAppEmpStatus: any;
	coAppIndustry: any;
	coAppOccupation: any;

	// Get Agency Records for Additional Subform
	agencyName: any;

	// Hide the notes and stage
	show_notes_stage = false;

	yes_interview = false; // For autopopulate Edit
	spinner = false; // Loader

	//Messages
	errorMessageLog: any = [];
	errorMessage: any;

	provinceList = [
		{ refValue: 'ON', picklistValue: 'Ontario' },
		{ refValue: 'QC', picklistValue: 'Quebec' },
		{ refValue: 'NS', picklistValue: 'Nova Scotia' },
		{ refValue: 'NB', picklistValue: 'New Brunswick' },
		{ refValue: 'MB', picklistValue: 'Manitoba' },
		{ refValue: 'BC', picklistValue: 'British Columbia' },
		{ refValue: 'PEI', picklistValue: 'Prince Edward Island' },
		{ refValue: 'SK', picklistValue: 'Saskatchewan' },
		{ refValue: 'AB', picklistValue: 'Alberta' },
		{ refValue: 'NL', picklistValue: 'Newfoundland and Labrador' },
		{ refValue: 'NT', picklistValue: 'Northwest Territories' },
		{ refValue: 'NU', picklistValue: 'Nunavut' },
		{ refValue: 'YT', picklistValue: 'Yukon' },
	];

	// Primary
	// Underwriting Expenses Form
	underwritingExForm = new UntypedFormGroup({
		Payment_Method: new UntypedFormControl(''),
		Next_Pay_Date: new UntypedFormControl(''),
		Last_Pay_Date: new UntypedFormControl(''),
		Review_any_payday_loan_usage: new UntypedFormControl(''),
		Payday_Loans_Comments: new UntypedFormControl(''),
		Overdraft_Limit: new UntypedFormControl(0),
		Is_this_a_joint_Account: new UntypedFormControl(''),
		Other_Bank_Account: new UntypedFormControl(''),
		When_was_the_last_time_you_filed_taxes: new UntypedFormControl(''),
		How_much_do_you_owe_Revenue_Canada: new UntypedFormControl(''),
		Have_you_setup_an_arrangement_with_the_CRA: new UntypedFormControl(''),
		Reason_for_falling_behind: new UntypedFormControl(''),
		Do_you_live_with_anyone_else: new UntypedFormControl(''),
		Dependents: new UntypedFormControl(''),
		are_u_homeowner: new UntypedFormControl(''),
		property_taxes: new UntypedFormControl(''),
		mortgage_property: new UntypedFormControl(''),
		mortgage_with: new UntypedFormControl(''),
		property_value: new UntypedFormControl(''),
		mortgage_balance: new UntypedFormControl(''),
		mortgage_interest: new UntypedFormControl(''),
		// 'uw_tier': new FormControl(''),
		Yes_No_Is_this_a_joint_Account: new UntypedFormControl(''),
		Overdraft_Limit_Question: new UntypedFormControl(''),
		Financial_Institution_Name: new UntypedFormControl(''),
		Financial_Institution_Number: new UntypedFormControl(''),
		Bank_Account_Number: new UntypedFormControl(''),
		Bank_Transit_No: new UntypedFormControl(''),
		Branch_Address: new UntypedFormControl(''),

		dob: new UntypedFormControl(''),
		unit: new UntypedFormControl(''),
		address: new UntypedFormControl(''),
		city: new UntypedFormControl(''),
		province: new UntypedFormControl(''),
		postalCode: new UntypedFormControl(''),
		creditt: new UntypedFormControl(''),
		accountBalance: new UntypedFormControl(''),
		agencies: new UntypedFormControl(''),
		jobStatus: new UntypedFormControl(''),
		company: new UntypedFormControl(''),
		position: new UntypedFormControl(''),
		empLength: new UntypedFormControl(''),
		salary: new UntypedFormControl(''),
		frequency: new UntypedFormControl(''),
		industry: new UntypedFormControl(''),
		occupation: new UntypedFormControl(''),

		totalMonthSubform: new UntypedFormControl(0),
		currentLoanSubform: new UntypedFormControl(0),
		ADDITIONAL_EXPENSES: this.fb.array([]), // Subform

		native_reserve: new UntypedFormControl(''),
		residency_status: new UntypedFormControl(''),
		staffing_agency: new UntypedFormControl(''),
		insolvency_status: new UntypedFormControl(''),
		active_judgements: new UntypedFormControl(''),
		child_tax: new UntypedFormControl(''),
		child_tax_amount: new UntypedFormControl(0),
		child_support: new UntypedFormControl(''),
		child_support_amount: new UntypedFormControl(0),
		other_loans_bills: new UntypedFormControl(''),
		other_loans_bills_amount: new UntypedFormControl(''),
	});

	// Loan Interview Notes
	loanInterviewNote = new UntypedFormGroup({
		subject: new UntypedFormControl('', Validators.required),
		description: new UntypedFormControl(''),
		communication: new UntypedFormControl('INT'),
		note: new UntypedFormControl('', Validators.required),
		subjectSearch: new UntypedFormControl(''),
	});

	// Loan Interview Stage
	loanInterviewStage = new UntypedFormGroup({
		Stage: new UntypedFormControl(''),
		stageSearch: new UntypedFormControl(''),
	});

	functions = new Functions();
	lookUps = new LookUps(this.customFunction);

	reloadLoanInterview: boolean = true; // Flag to prevent loan interview re-render

	readonly loanDupCols: string[] = [
		'loanNumber',
		'name',
		'dob',
		'email',
		'postalcode',
		'phone',
		'address',
		'province',
	];
	readonly liabilities = LIABILITYLIST;
	readonly residencies = RESIDENCYLIST;
	readonly insolvencyList = INSOLVENCYLIST;
	isLoaded = false;
	filteredSubjects = new BehaviorSubject<any[]>([]);
	filteredStages = new BehaviorSubject<any[]>([]);
	allSubjects: any;
	getDisplayedStage: string = '';
	constructor(
		private readonly activatedRoute: ActivatedRoute,
		private readonly apiService: LegacyApiService,
		private readonly fb: UntypedFormBuilder,
		private readonly customFunction: CustomFunctionService,
		private readonly dialog: MatDialog,
		private readonly loanInterviewService: LoanInterviewService,
		private router: Router,
		private loanMetaService: LoanMetaService,
		private readonly sharedService: SharedServiceService
	) {}

	async ngOnInit() {
		this.activatedRoute.url.subscribe((event) => {
			this.currentRoute = event[0].path;
		});
		this.activatedRoute.pathFromRoot[1].url.subscribe((val) => {
			this.currentZohoAppIdFromUrl = val?.[2]?.path;
		});

		this.errorMessageLog = [];
		this.applicationType = '';
		this.loanInterviewNote
			.get('subjectSearch')
			.valueChanges.subscribe((val) => {
				this.filterSubjects(val);
			});

		this.loanInterviewStage.get('stageSearch').valueChanges.subscribe((val) => {
			this.filterStages(val);
		});
	}

	isDuplicateLoan: any;
	checkDuplicateLoan(data: any) {
		this.loanInterviewService.checkDuplicateLoan(data).subscribe({
			next: (res) => {
				this.isDuplicateLoan = res;
				// console.log(this.isDuplicateLoan,"DATAAAAAAAAAAAAAAAAAAA+++++++++++++++++++")
			},
			error: (err) => {
				this.isDuplicateLoan = null;
			},
		});
	}

	dummyLoader() {
		setTimeout(() => {
			this.isLoaded = true;
		}, 2000);
	}

	//INCLUDE THIS IN THE SEARCH COMPONENT TO OPEN LOAN META FOR SPECIFIC LOAN FOR NLS (NEW COLOUMN FOR NLS OPEN)
	openLoanMeta(loan_number: string) {
		this.loanMetaService.setQueue([loan_number], loan_number, false);
		// this.router.navigate(['loan-meta']);
		const url = this.router.serializeUrl(
			this.router.createUrlTree(['loan-meta'])
		);

		// 2. Open in a new tab/window
		window.open(url, '_blank');
	}

	private async initializeData() {
		if (this.application) {
			this.getLookups();
			this.getAgencyRecords();

			// Only populate data if we have an application type selected
			if (this.applicationType) {
				this.spinner = false;

				// Populate form data from application object
				this.populateFormFromApplication();

				this.checkDuplicateLoan(this.application);

				// Populate the Interview questions Subform
				await this.populateUnderwritingSubform();
				this.loadSubject();
			}
		}

		if (this.currentUser) {
			this.tdsr = 0;
			this.totalMonthlyIncome = 0;
			// this.applicationType = '';
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.reloadLoanInterview) {
			this.application ??= changes?.application?.currentValue;
			this.currentUser ??= changes?.currentUser?.currentValue;
			this.initializeData();
		}
	}

	switchInterview(e: any) {
		if (!this.applicationType) {
			this.resetPrimaryLoanInterview();
		}

		if (e === 'Primary' || e === 'Co-Applicant') {
			this.spinner = true;
			this.yes_interview = true;
			this.applicationType = e;
			this.initializeData();
			// document.getElementById('loanInterviewDisplay').style.display = 'block';
			// // document.getElementById('loanInterviewDisplay')?.style.setProperty('display', 'block');
			this.editToStartTimer();
			this.reloadLoanInterview = false; // Prevent re-render of the loan interview once its clicked.
			this.dummyLoader();
		}
	}

	selectedItem: any;
	hideMessageOnLoad() {
		document.getElementById('saveMessage').style.display = 'none';
	}

	/**
	 * Populate form data from the application object instead of API call
	 */
	private populateFormFromApplication() {
		if (!this.application || !this.applicationType) return;

		// Common data for both Primary and Co-Applicant
		if (this.application.Account_Name != null) {
			this.underwritingExForm.patchValue({
				agencies: this.application.Account_Name.name,
			});
		}

		this.underwritingExForm.patchValue({
			creditt: this.application.Creditt,
			accountBalance: this.application.Account_Bal,
			currentLoanSubform: this.application.Scheduled_Payments_Monthly,
		});

		// Set stage
		if (this.stageName && this.application.Stage) {
			const stage = this.customFunction.singleFilterName(
				this.stageName,
				'display_value',
				this.application.Stage
			);
			if (stage && stage[0]) {
				this.loanInterviewStage.patchValue({
					Stage: stage[0]['id'],
				});
			}
		}

		if (this.applicationType === 'Primary') {
			this.Deal_Name = this.application.Deal_Name;
			this.provinceName = this.application.Province1;

			this.underwritingExForm.patchValue({
				dob: this.application.Date_of_Birth,
				unit: this.application.Address_Line_2,
				address: this.application.Address1,
				city: this.application.City,
				province: this.application.Province1,
				postalCode: this.application.Postal_Code,
				jobStatus: this.application.Employment_Status1,
				company: this.application.Employer,
				position: this.application.Position,
				empLength: this.application.Length_of_Employment,
				salary: this.application.Income_net_paycheque_income,
				frequency: this.application.Pay_Frequency2,
				industry: this.application.Industry,
				occupation: this.application.Occupation,
				Financial_Institution_Name: this.application.Financial_Institution_Name,
				Financial_Institution_Number:
					this.application.Financial_Institution_Number,
				Bank_Account_Number: this.application.Bank_Account_Number,
				Bank_Transit_No: this.application.Bank_Transit_No,
				Branch_Address: this.application.Branch_Address,
			});

			this.underwritingExForm
				.get('industry')
				.setValue(this.application.Industry);
			this.selectedItem = this.application.Industry;
		}

		if (this.applicationType === 'Co-Applicant') {
			this.Deal_Name =
				this.application.Co_Applicant_Name +
				' ' +
				this.application.Guarantor_Name;
			this.provinceName = this.application.Co_Applicant_Province;

			this.underwritingExForm.patchValue({
				dob: this.application.Co_Applicant_Date_of_Birth,
				unit: this.application.Co_Applicant_Address_Line_2_Unit_number,
				address: this.application.Co_Applicant_Property_Address,
				city: this.application.Co_Applicant_City,
				province: this.application.Co_Applicant_Province,
				postalCode: this.application.Co_Applicant_Postal_Code,
				jobStatus: this.application.Co_Applicant_Status,
				company: this.application.Co_Applicant_Employer,
				position: this.application.Secondary_Position,
				empLength: this.application.Secondary_Years_Worked,
				salary: this.application.Sec_Annual_Income,
				frequency: this.application.Co_Applicant_Pay_Frequency,
				industry: this.application.Co_Applicant_Industry,
				occupation: this.application.Co_Applicant_Occupation,
				Financial_Institution_Name:
					this.application.Co_Applicant_Financial_Institution_Name,
				Financial_Institution_Number:
					this.application.Co_ApplicantFinancial_Institution_Number1,
				Bank_Account_Number: this.application.Co_Applicant_Bank_Account,
				Bank_Transit_No: this.application.Co_Applicant_Bank_Transit_No,
				Branch_Address: this.application.Co_Applicant_Branch_Address,
			});
		}
	}

	// ----------------------UNDERWRITING LOAN INTERVIEW PRIMARY-----------------------------------------------------------------------------------
	interviewHomeOwner(e: any) {
		if (e.target.value === 'Yes') {
		} else {
			this.underwritingExForm.get('property_taxes').reset();
			this.underwritingExForm.get('mortgage_property').reset();
			this.underwritingExForm.get('mortgage_with').reset();
			this.underwritingExForm.get('property_value').reset();
			this.underwritingExForm.get('mortgage_balance').reset();
			this.underwritingExForm.get('mortgage_interest').reset();
		}
	}

	underwritingPool: any;
	/* SUB FORM of ADDITIONAL DEBTS */
	addUnderwitingSubform() {
		this.underwritingPool = [];
		this.underwritingPool = this.underwritingExForm.get(
			'ADDITIONAL_EXPENSES'
		) as UntypedFormArray;
		this.newAddExpenses = this.fb.group({
			questions_subform: '',
			Type: '',
			Name1: '',
			Amount: '0',
			liabilities: '',
		});

		this.underwritingPool.push(this.newAddExpenses);
	}

	// To fetch and populate the records that are present into the subform
	async populateUnderwritingSubform() {
		return new Promise((resolve, reject) => {
			this.apiService.getInterviewQuestions().subscribe((res) => {
				if (res.message === 'Success') {
					this.questionBanks = res.data;

					// Push the values into subform array
					this.underwritingPool = this.underwritingExForm.get(
						'ADDITIONAL_EXPENSES'
					) as UntypedFormArray;

					let listArray = this.underwritingExForm.get(
						'ADDITIONAL_EXPENSES'
					) as UntypedFormArray;
					while (listArray.length !== 0) {
						listArray.removeAt(0);
					}
					for (let i = 0; i < this.questionBanks.length; i++) {
						this.underwritingPool.push(
							this.fb.group({
								questions_subform: this.questionBanks[i].question_id,
								Type: this.questionBanks[i].expenses_type,
								Name1: this.questionBanks[i].creditor_name,
								Amount: this.questionBanks[i].amount,
								liabilities: this.questionBanks[i]['liabilities'],
							})
						);
					}
					this.totalSubformAdditional = this.customFunction.sumNumbers(
						res.data,
						'amount'
					);
					resolve(true);
				} else {
					resolve(false);
				}
			});
		});
	}

	// Remove expenses
	removeSubformExpenses(i: any) {
		let listArray = this.underwritingExForm.get(
			'ADDITIONAL_EXPENSES'
		) as UntypedFormArray;
		listArray.removeAt(i);
		this.sumAmount();
	}

	// Event calculation
	addSubformAmount() {
		document.addEventListener('click', (e) => {
			this.sumAmount();
		});
	}
	addSubformAmountEnter(e: any) {
		if (e.key === 'Enter') {
			this.sumAmount();
		}
	}

	// Sum the amounts on subform for additional expenses
	sumAmount() {
		this.totalSubformAdditional = this.underwritingExForm
			.get('ADDITIONAL_EXPENSES')
			.value.map((item: any) => item.Amount)
			.reduce((prev: any, curr: any) => parseFloat(prev) + parseFloat(curr));
		this.totalMonthSubform();
	}

	// event calculation
	clickedTotalMonthSubform() {
		// document.addEventListener("click", e => {
		this.totalMonthSubform();
		// })
	}
	clickedCurrentLoanSubform() {
		// document.addEventListener("click", e => {
		this.currentLoanSubform();
		// })
	}

	enteredTotalMonthSubform(e: any) {
		if (e.key === 'Enter') {
			this.totalMonthSubform();
		}
	}
	enteredCurrentLoanSubform(e: any) {
		if (e.key === 'Enter') {
			this.currentLoanSubform();
		}
	}

	// Calculate the tdsr on Total Monthly Income changes
	totalMonthSubform() {
		let current: any;
		if (
			this.underwritingExForm.get('currentLoanSubform').value != '' &&
			this.underwritingExForm.get('currentLoanSubform').value != null &&
			this.underwritingExForm.get('currentLoanSubform').value != 0
		) {
			current = this.underwritingExForm.get('currentLoanSubform').value;
		} else {
			current = 0;
		}

		if (
			this.underwritingExForm.get('totalMonthSubform').value != 0 &&
			this.underwritingExForm.get('totalMonthSubform').value != '' &&
			this.underwritingExForm.get('totalMonthSubform').value != null
		) {
			this.tdsr = (
				((this.totalSubformAdditional + parseFloat(current)) /
					parseFloat(this.underwritingExForm.get('totalMonthSubform').value)) *
				100
			).toFixed();
		} else {
			this.tdsr = 0;
		}
	}

	// Calculate the tdsr on Current Loan Amount Payments (Monthly) changes
	currentLoanSubform() {
		let current = this.underwritingExForm.get('currentLoanSubform').value;

		if (current != '' && current != null) {
			if (
				this.underwritingExForm.get('totalMonthSubform').value != 0 &&
				this.underwritingExForm.get('totalMonthSubform').value != '' &&
				this.underwritingExForm.get('totalMonthSubform').value != null
			) {
				this.tdsr = (
					((this.totalSubformAdditional + parseFloat(current)) /
						parseFloat(
							this.underwritingExForm.get('totalMonthSubform').value
						)) *
					100
				).toFixed();
			} else {
				this.tdsr = 0;
			}
		}
	}

	resetPrimaryLoanInterview() {
		this.underwritingExForm.reset();
		this.totalSubformAdditional = '';
		this.displayMonthlyIncome = '';
		this.totalMonthNumbers = '';
		this.totalMonthlyIncome = 0;
		this.tdsr = 0;
		this.hideMessageOnLoad();
		this.show_notes_stage = false;
		// this.populateUnderwritingSubform()
	}

	loadSubject() {
		this.apiService.getNoteSubjects().subscribe((res) => {
			if (res.message == 'Success') {
				this.subjects = res.data;
				this.allSubjects = [...this.subjects];
				this.filteredSubjects.next(this.allSubjects.slice());
				this.loanInterviewNote.get('subjectSearch').updateValueAndValidity();
			}
		});
	}

	filterSubjects(val: string) {
		if (!this.allSubjects || !this.allSubjects.length) return;

		const search = (val || '').toLowerCase();
		const filtered = this.allSubjects.filter((s) => {
			const name = (s.subject || '').toLowerCase();
			return name.includes(search);
		});
		this.filteredSubjects.next(filtered);
	}

	filterStages(val: string) {
		if (!this.stageName || !this.stageName.length) return;

		const search = (val || '').toLowerCase();
		const filtered = this.stageName.filter((s) => {
			const name = (s.display_value || '').toLowerCase();
			return name.includes(search);
		});
		this.filteredStages.next(filtered);
	}

	matchSubject(subject: string) {
		this.apiService.getSubjectDesc(subject).subscribe((res) => {
			if (res.message == 'Success') {
				try {
					this.loanInterviewNote.patchValue({
						description: res.data[0]['description'],
					});
				} catch (e) {
					this.loanInterviewNote.patchValue({
						description: '',
					});
				}
			}
		});
	}

	saveLoanInterviewNotes() {
		if (this.currentUser?.position === 'UW') {
			(<HTMLInputElement>document.getElementById('saveLTNoteButton')).disabled =
				true;
			document.getElementById('successfulNote').innerHTML =
				'Save in progress...';
			document.getElementById('successfulNote').style.color = 'orange';
			document.getElementById('successfulNote').style.display = 'block';
			// Insert on local platform
			this.loanInterviewService
				.insertLoanInterviewNotes(
					this.loanInterviewNote.value,
					this.application.id,
					this.currentUser?.zoho_owner_id,
					this.Deal_Name,
					this.currentUser?.full_name
				)
				.subscribe((res) => {
					if (res.message == 'Success') {
						(<HTMLInputElement>(
							document.getElementById('saveLTNoteButton')
						)).disabled = false;
						document.getElementById('successfulNote').innerHTML =
							'Save successful!';
						document.getElementById('successfulNote').style.color = 'green';
						document.getElementById('successfulNote').style.display = 'block';
						let app_note_id = '';
						try {
							app_note_id = res['data'][0]['app_note_id'];
						} catch (err) {
							app_note_id = '';
						}
						this.apiService
							.addLoanInterviewNotesZOHO(
								this.loanInterviewNote.value,
								this.application.id,
								this.currentUser?.zoho_owner_id
							)
							.subscribe((res) => {
								let zoho_note_id = res['app_id'];
								// console.log(zoho_note_id)
								// console.log(app_note_id)
								this.apiService
									.updateNoteIDLocal(app_note_id, zoho_note_id)
									.subscribe((res) => {
										console.log(res);
									});
							});
					} else {
						(<HTMLInputElement>(
							document.getElementById('saveLTNoteButton')
						)).disabled = false;
						document.getElementById('successfulNote').innerHTML =
							'Platform: Save unsuccessful!';
						document.getElementById('successfulNote').style.color = 'red';
						document.getElementById('successfulNote').style.display = 'block';
					}
				});
		} else {
			(<HTMLInputElement>document.getElementById('saveLTNoteButton')).disabled =
				false;
			document.getElementById('successfulNote').innerHTML =
				'Save not allowed. Contact IT!';
			document.getElementById('successfulNote').style.color = 'red';
			document.getElementById('successfulNote').style.display = 'block';
		}
	}

	editToStartTimer() {
		this.timeInfo = {
			applicationID: this.application.id,
			applicantType: this.applicationType,
			duration: 0,
			underwriter: this.currentUser?.full_name,
			start_date: new Date(),
			end_date: '',
			action: '',
		};
		this.readOnly = false;
		this.running = !this.running;
		if (this.running) {
			this.startText = 'Stop';
			const startTime = Date.now() - (this.counter || 0);
			this.timerRef = setInterval(() => {
				this.counter = Date.now() - startTime;
				this.display_time = this.editTime(this.counter);
			});
		} else {
			this.startText = 'Resume';
			clearInterval(this.timerRef);
		}
	}
	editTime(milliseconds: any) {
		return new Date(milliseconds).toISOString().slice(11, 19);
	}

	clearTimer(applicationID: any, applicantType: any) {
		this.timeInfo.end_date = new Date();
		this.timeInfo.duration = this.counter;
		//Enter the time info in the table
		this.apiService.recordLoanInterviewDuration(this.timeInfo).subscribe(() => {
			console.log('Insert Timing Info into Durationg Table');
			// console.log(res)
		});
		this.apiService
			.updateLoanInterviewComplete(applicationID, applicantType)
			.subscribe(() => {
				console.log('Update Loan Interview Complete');
				// console.log(res)
			});
		this.readOnly = true;
		this.running = false;
		this.startText = 'Start';
		this.counter = undefined;
		clearInterval(this.timerRef);
	}

	// Information from income calculator modal
	openCalc() {
		const dialogRef = this.dialog.open(MonthlyincomecalcComponent, {
			width: '300px',
		});

		dialogRef.afterClosed().subscribe((result) => {
			this.income_calc_result = result.dataExpression;
			this.underwritingExForm.patchValue({
				totalMonthSubform: result.data['averageSalary'],
			});
			this.totalMonthlyIncome = result.dataExpression;
			this.totalMonthSubform();
		});
	}

	getLookups() {
		this.apiService.getLookupsdeals().subscribe((res) => {
			if (res['message']['statusCode'] == '200') {
				let arr1: any;
				arr1 = JSON.parse(res.message.body);
				this.stageName = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Stage'
				)[0]['pick_list_values'];
				this.filteredStages.next(this.stageName.slice());
				this.creditorName = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Creditt'
				)[0]['pick_list_values'];
				this.primaryEmpStatus = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Employment_Status1'
				)[0]['pick_list_values'];
				this.primaryPayFrequency = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Pay_Frequency2'
				)[0]['pick_list_values'];
				this.primaryIndustry = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Industry'
				)[0]['pick_list_values'];
				this.primaryOccupation = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Occupation'
				)[0]['pick_list_values'];

				this.coAppEmpStatus = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Co_Applicant_Status'
				)[0]['pick_list_values'];
				this.coAppIndustry = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Co_Applicant_Industry'
				)[0]['pick_list_values'];
				this.coAppOccupation = this.customFunction.singleFilterName(
					arr1.fields,
					'api_name',
					'Co_Applicant_Occupation'
				)[0]['pick_list_values'];
			}
		});
	}

	getAgencyRecords() {
		this.apiService.getAgencies().subscribe((res) => {
			if (res['message']['statusCode'] == '200') {
				let arr = JSON.parse(res.message.body);
				this.agencyName = arr.data;
			}
		});
	}

	/**
	 * To get the display value of stage
	 */
	onStageSelection(event: MatSelectChange) {
		const id = event.value;
		this.getDisplayedStage = event.source.triggerValue;
	}

	saveStageLoanInterview() {
		(<HTMLInputElement>document.getElementById('saveLTStageButton')).disabled =
			true;
		document.getElementById('successfulStage').style.display = 'block';
		document.getElementById('successfulStage').innerHTML =
			'Save in progress...';
		document.getElementById('successfulStage').style.color = 'orange';
		this.apiService
			.updateSummaryStage(
				this.loanInterviewStage.get('Stage').value,
				this.application.id,
				this.application.Stage_History_ID,
				this.currentUser?.zoho_owner_id
			)
			.subscribe((res) => {
				if (res['message']['statusCode'] == '200') {
					(<HTMLInputElement>(
						document.getElementById('saveLTStageButton')
					)).disabled = false;
					document.getElementById('successfulStage').style.display = 'block';
					document.getElementById('successfulStage').innerHTML =
						'Save Successful';
					document.getElementById('successfulStage').style.color = 'green';
					this.sharedService.updateStage(this.getDisplayedStage); // To save the stage name on Summary bar
					// this.applicationChange.emit(this.application);	// Event emitter not working
				} else {
					(<HTMLInputElement>(
						document.getElementById('saveLTStageButton')
					)).disabled = false;
					document.getElementById('successfulStage').style.display = 'block';
					document.getElementById('successfulStage').innerHTML =
						'ZOHO: Save unsuccessful';
					document.getElementById('successfulStage').style.color = 'red';
				}
			});
	}

	async insertLocalUnderwritingPrimary() {
		return new Promise((resolve, reject) => {
			this.loanInterviewService
				.addLoanInterviewlocal(
					this.underwritingExForm.value,
					this.application.id,
					this.underwritingID,
					this.currentUser?.zoho_owner_id,
					this.applicationType,
					this.totalSubformAdditional,
					this.tdsr,
					this.currentUser?.full_name
				)
				.subscribe((res) => {
					console.log(res, 'addLoanInterviewlocal@@@@@@@@@@@@@@@@@@@@@');
					if (res['status']) {
						this.apiService
							.addunderwritingincomecalculation(
								this.application.id,
								this.applicationType,
								this.income_calc_result
							)
							.subscribe((res) => {
								console.log(res, 'INSERT INCOME');
							});
						resolve(true);
					} else {
						this.errorMessageLog.push(JSON.stringify(res['message']['data']));
						resolve(false);
						console.log(res);
					}
				});
		});
	}

	async pushZohoApplicationDetails() {
		return new Promise((resolve, reject) => {
			this.apiService
				.zohoInterviewerApplication(
					this.underwritingExForm.value,
					this.application.id,
					this.currentUser?.full_name,
					this.tdsr,
					this.applicationType
				)
				.subscribe((res) => {
					if (res['message']['statusCode'] != '200') {
						console.log(res['message']['body']);
						this;
						this.errorMessageLog.push(res['message']['body']);
						resolve(false);
						console.log('Zoho Application push: Fail!');
					} else {
						resolve(true);
						console.log('Zoho Application push: Success!');
					}
				});
		});
	}

	// Save Locally, ZOHO Application, ZOHO Underwriting
	saveInterviewScript() {
		if (this.currentUser?.position === 'UW') {
			(<HTMLInputElement>(
				document.getElementById('saveLoanInterviewButton')
			)).disabled = true;
			document.getElementById('saveMessage').style.display = 'block';
			document.getElementById('saveMessage').innerHTML = 'Save in progress...';
			document.getElementById('saveMessage').style.color = 'orange';
			Promise.all([
				this.insertLocalUnderwritingPrimary(),
				this.pushZohoApplicationDetails(),
			])
				.then((result) => {
					const checkTrue = result.filter((value) => value === true);
					if (checkTrue.length === 2) {
						if (this.yes_interview === true) {
							this.clearTimer(this.application.id, this.applicationType);
							this.yes_interview = false;
						}
						this.show_notes_stage = true;
						(<HTMLInputElement>(
							document.getElementById('saveLoanInterviewButton')
						)).disabled = false;
						document.getElementById('saveMessage').innerHTML =
							'Loan Interview Successful!';
						document.getElementById('saveMessage').style.color = 'green';
						document.getElementById('saveMessage').style.display = 'block';
					} else {
						this.show_notes_stage = false;
						this.errorMessage = this.errorMessageLog;
						(<HTMLInputElement>(
							document.getElementById('saveLoanInterviewButton')
						)).disabled = false;
						document.getElementById('saveMessage').style.display = 'block';
						document.getElementById('saveMessage').innerHTML = 'Save failed!';
						document.getElementById('saveMessage').style.color = 'red';
					}
				})
				.catch((e) => {
					console.error(e.message, 'Save failed: PromiseAll!');
				});
		} else {
			(<HTMLInputElement>(
				document.getElementById('saveLoanInterviewButton')
			)).disabled = false;
			document.getElementById('saveMessage').innerHTML =
				'Save not allowed. Contact IT!';
			document.getElementById('saveMessage').style.color = 'red';
			document.getElementById('saveMessage').style.display = 'block';
		}
	}

	clearErrors() {
		this.errorMessageLog = [];
		this.errorMessage = '';
	}

	handleReset(selectedItem: string, formName: string, controlName: string) {
		if (selectedItem === 'No') {
			(this as any)[formName]?.get(controlName)?.reset();
		} else {
			return;
		}
	}

	ngOnDestroy() {
		// No subscriptions to unsubscribe
	}
}
